import ms from 'ms';

export default str => ms(str) / 1000;
